import { NgModule } from '@angular/core';
import {LogPipe} from "@app/pipes/log/log.pipe";

@NgModule({
  declarations: [LogPipe],
  exports: [LogPipe],
})
export class LogPipeModule {}
